import setShowListPane from './setShowListPane';
import setShowReadingPane from './setShowReadingPane';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { action } from 'satcheljs/lib/legacy';
/**
 * Decides whether to hide LP after a print row action in SLV
 */
export default action('onPrintRow')(function onPrintRow() {
    if (getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ===
        ReadingPanePosition.Off) {
        setShowReadingPane(true /* showReadingPane */);
        setShowListPane(false /* showListPane */);
    }
});
//# sourceMappingURL=onPrintRow.js.map